(function () {
  'use strict';

  function makeToolCard(config) {
    var article = document.createElement('article');
    article.className = 'cjs-brand-page__service-card cjs-brand-journey-tools__card';

    var label = document.createElement('p');
    label.className = 'cjs-brand-page__service-label cjs-brand-journey-tools__label';
    label.textContent = config.label;

    var heading = document.createElement('h3');
    heading.textContent = config.heading;

    var text = document.createElement('div');
    text.className = 'cjs-brand-page__service-text cjs-brand-journey-tools__text rte';
    text.innerHTML = '<p>' + config.text + '</p>';

    var link = document.createElement('a');
    link.className = 'cjs-brand-page__card-link';
    link.href = config.href;
    link.innerHTML = '<span>' + config.cta + '</span><span aria-hidden="true">→</span>';

    article.appendChild(label);
    article.appendChild(heading);
    article.appendChild(text);
    article.appendChild(link);
    return article;
  }

  var tools = {
    hardware: {
      label: 'Hardware & fitment',
      heading: 'Shock Hardware Database',
      text: 'Find the correct mounting hardware size for your bike and rear shock, then move straight to the matching hardware options.',
      cta: 'Find Shock Hardware',
      href: '/pages/shock-hardware-database'
    },
    hours: {
      label: 'Service timing',
      heading: 'Suspension Hour Meter',
      text: 'Track your ride hours and see when your fork, rear shock or dropper is coming up for its next service.',
      cta: 'Check Service Hours',
      href: '/pages/suspension-hour-meter'
    },
    spring: {
      label: 'Spring setup',
      heading: 'Spring Rate Calculator',
      text: 'Calculate a starting coil spring rate from your rider, bike and shock details, then move on to compatible spring options.',
      cta: 'Calculate Spring Rate',
      href: '/pages/spring-rate-calculator'
    }
  };

  function toolKeysForPath() {
    var path = String(window.location.pathname || '').toLowerCase();

    if (
      path === '/pages/ks-dropper-service' ||
      path === '/pages/specialized-dropper-service' ||
      path === '/pages/bikeyoke-dropper-service' ||
      path === '/pages/race-face-dropper-service' ||
      path === '/pages/manitou-suspension-service'
    ) {
      return ['hours'];
    }

    if (path === '/pages/x-fusion-suspension-service') {
      return ['hardware', 'hours'];
    }

    return ['hardware', 'hours', 'spring'];
  }

  function toolIntro(keys) {
    if (keys.length === 1) {
      return 'Track service timing before booking your next workshop service.';
    }

    if (keys.length === 2) {
      return 'Useful tools for rear-shock hardware fitment and service timing before booking or ordering parts.';
    }

    return 'Useful tools to help you find the correct shock hardware, understand when your suspension is due for service and calculate a starting coil spring rate before booking or ordering parts.';
  }

  function buildToolsSection() {
    var keys = toolKeysForPath();
    var section = document.createElement('section');
    section.className = 'cjs-brand-page__services cjs-brand-journey-tools';
    section.setAttribute('data-cjs-brand-journey-tools', '');

    var header = document.createElement('div');
    header.className = 'cjs-brand-page__section-header cjs-brand-journey-tools__header';
    header.innerHTML =
      '<div>' +
        '<p class="cjs-brand-page__section-eyebrow">Suspension Tools &amp; Resources</p>' +
        '<h2>Helpful Suspension Tools</h2>' +
      '</div>' +
      '<div class="cjs-brand-page__section-copy rte"><p>' + toolIntro(keys) + '</p></div>';

    var grid = document.createElement('div');
    grid.className = 'cjs-brand-page__service-grid cjs-brand-journey-tools__grid';
    grid.setAttribute('data-cjs-tool-count', String(keys.length));

    keys.forEach(function (key) {
      grid.appendChild(makeToolCard(tools[key]));
    });

    section.appendChild(header);
    section.appendChild(grid);
    return section;
  }

  function replaceWorkshopServices(page) {
    if (!page) return;

    var existingTools = page.querySelector('[data-cjs-brand-journey-tools]');
    var workshop = page.querySelector('.cjs-brand-page__services');

    if (existingTools) {
      if (workshop && workshop !== existingTools) workshop.remove();
      return;
    }

    var toolsSection = buildToolsSection();

    if (workshop && workshop.parentNode) {
      workshop.replaceWith(toolsSection);
      return;
    }

    var products = page.querySelector('.cjs-brand-page__products');
    if (products && products.parentNode) products.insertAdjacentElement('afterend', toolsSection);
  }

  function originalShopifyImageUrl(value) {
    var source = String(value || '');
    if (!source) return '';

    try {
      var url = new URL(source, window.location.href);
      url.searchParams.delete('width');
      url.searchParams.delete('height');
      url.searchParams.delete('crop');
      return url.toString();
    } catch (error) {
      return source
        .replace(/([?&])(width|height|crop)=[^&]*&?/g, '$1')
        .replace(/[?&]$/, '');
    }
  }

  function sizeHeroLogo(panel, logo) {
    var naturalWidth = logo.naturalWidth || 0;
    var targetWidth = naturalWidth ? Math.max(170, Math.min(300, Math.floor(naturalWidth / 2))) : 280;
    panel.style.setProperty('--cjs-brand-logo-max-width', targetWidth + 'px');
  }

  function enhanceBrandHero(page) {
    if (!page) return;

    var hero = page.querySelector('.cjs-brand-page__hero');
    var panel = page.querySelector('.cjs-brand-page__hero-logo-wrap');
    var logo = panel ? panel.querySelector('.cjs-brand-page__hero-logo') : null;
    if (!hero || !panel || !logo) return;

    hero.setAttribute('data-cjs-brand-hero-styled', '');
    panel.classList.add('cjs-brand-hero-logo-panel');
    logo.setAttribute('data-cjs-brand-hero-logo', '');

    var stage = panel.querySelector('.cjs-brand-hero-logo-stage');
    if (!stage) {
      stage = document.createElement('div');
      stage.className = 'cjs-brand-hero-logo-stage';
      panel.insertBefore(stage, logo);
      stage.appendChild(logo);
    }

    var source = logo.getAttribute('src') || logo.currentSrc || '';
    var originalSource = originalShopifyImageUrl(source);
    if (originalSource) {
      logo.removeAttribute('srcset');
      logo.removeAttribute('sizes');
      logo.src = originalSource;
    }

    logo.loading = 'eager';
    logo.decoding = 'sync';
    try { logo.fetchPriority = 'high'; } catch (error) {}

    if (logo.complete && logo.naturalWidth) sizeHeroLogo(panel, logo);
    else logo.addEventListener('load', function () { sizeHeroLogo(panel, logo); }, { once: true });
  }

  function addStyles() {
    if (document.getElementById('cjs-brand-journey-links-styles')) return;

    var style = document.createElement('style');
    style.id = 'cjs-brand-journey-links-styles';
    style.textContent =
      '.cjs-brand-journey-tools{padding-top:var(--cjs-section-spacing,72px);padding-bottom:var(--cjs-section-spacing,72px);border-top:1px solid var(--cjs-border,#e6e2dd);}' +
      '.cjs-brand-journey-tools__grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:18px;}' +
      '.cjs-brand-journey-tools__grid[data-cjs-tool-count="2"]{grid-template-columns:repeat(2,minmax(0,1fr));max-width:760px;}' +
      '.cjs-brand-journey-tools__grid[data-cjs-tool-count="1"]{grid-template-columns:minmax(0,360px);}' +
      '.cjs-brand-journey-tools__card{padding:28px!important;transition:transform .18s ease,border-color .18s ease,box-shadow .18s ease;}' +
      '.cjs-brand-journey-tools__card:hover{transform:translateY(-2px);border-color:#d3cbc4;box-shadow:0 10px 26px rgba(17,17,17,.045);}' +
      '.cjs-brand-journey-tools__label{margin-bottom:10px!important;}' +
      '.cjs-brand-journey-tools__card h3{font-size:23px!important;line-height:1.12!important;letter-spacing:-.025em!important;}' +
      '.cjs-brand-journey-tools__text{font-size:13.5px!important;line-height:1.62!important;}' +
      '.cjs-brand-journey-tools__card .cjs-brand-page__card-link{margin-top:auto;padding-top:24px;}' +
      '.cjs-brand-page__hero[data-cjs-brand-hero-styled]{min-height:480px!important;isolation:isolate;background:linear-gradient(112deg,#050505 0%,#0a0a0a 57%,#151011 100%)!important;}' +
      '.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__hero-media{opacity:.13!important;filter:saturate(.68) contrast(1.08) brightness(.58);}' +
      '.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__hero-overlay{background:linear-gradient(90deg,rgba(0,0,0,.97) 0%,rgba(0,0,0,.91) 38%,rgba(0,0,0,.76) 62%,rgba(0,0,0,.50) 100%)!important;opacity:1!important;}' +
      '.cjs-brand-page__hero[data-cjs-brand-hero-styled]::before{content:"";position:absolute;z-index:1;inset:0;pointer-events:none;background:repeating-linear-gradient(118deg,rgba(255,255,255,.018) 0 1px,transparent 1px 44px),repeating-linear-gradient(28deg,rgba(255,255,255,.012) 0 1px,transparent 1px 72px);mask-image:linear-gradient(90deg,transparent 0%,rgba(0,0,0,.42) 34%,#000 100%);}' +
      '.cjs-brand-page__hero[data-cjs-brand-hero-styled]::after{content:"";position:absolute;z-index:2;right:-8%;bottom:-42%;width:64%;height:135%;pointer-events:none;background:radial-gradient(ellipse at 56% 42%,rgba(168,50,58,.30) 0%,rgba(168,50,58,.14) 29%,rgba(168,50,58,.04) 48%,rgba(168,50,58,0) 72%);}' +
      '.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__hero-inner{z-index:3!important;padding-top:54px!important;padding-bottom:54px!important;}' +
      '.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__hero-grid{grid-template-columns:minmax(0,1.06fr) minmax(390px,500px)!important;gap:76px!important;align-items:center!important;}' +
      '.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__title{max-width:760px!important;font-size:clamp(46px,5.25vw,74px)!important;line-height:.98!important;letter-spacing:-.047em!important;}' +
      '.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__hero-text{max-width:760px!important;margin-top:22px!important;font-size:clamp(17px,1.55vw,20px)!important;line-height:1.55!important;opacity:.88!important;}' +
      '.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__eyebrow{color:#d84850!important;letter-spacing:.15em!important;}' +
      '.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__breadcrumbs{margin-bottom:29px!important;opacity:.68!important;}' +
      '.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__hero-actions{margin-top:28px!important;gap:10px!important;}' +
      '.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__button{min-height:47px!important;padding:12px 22px!important;border-radius:6px!important;}' +
      '.cjs-brand-page__hero-logo-wrap.cjs-brand-hero-logo-panel{position:relative;isolation:isolate;display:block!important;width:100%;min-height:300px;overflow:visible;padding:30px!important;border:0!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;transform:none!important;}' +
      '.cjs-brand-page__hero-logo-wrap.cjs-brand-hero-logo-panel::before{content:"";position:absolute;z-index:0;inset:30px 10px 6px 24px;border:1px solid rgba(255,255,255,.13);border-radius:18px;background:linear-gradient(145deg,#282828 0%,#141414 56%,#090909 100%);box-shadow:18px 22px 0 rgba(168,50,58,.16),0 34px 72px rgba(0,0,0,.52);transform:rotate(-3deg);}' +
      '.cjs-brand-page__hero-logo-wrap.cjs-brand-hero-logo-panel::after{content:"";position:absolute;z-index:0;inset:23px 4px 12px 17px;border:1px solid rgba(201,55,65,.78);border-radius:19px;box-shadow:0 0 28px rgba(168,50,58,.18);transform:rotate(-3deg);pointer-events:none;}' +
      '.cjs-brand-hero-logo-stage{position:relative;z-index:2;display:flex;min-height:240px;align-items:center;justify-content:center;padding:42px 46px;overflow:hidden;border:1px solid rgba(255,255,255,.85);border-radius:14px;background:linear-gradient(145deg,#ffffff 0%,#f7f5f2 62%,#e8e4df 100%);box-shadow:inset 0 1px 0 rgba(255,255,255,.95),0 20px 46px rgba(0,0,0,.34);}' +
      '.cjs-brand-hero-logo-stage::before{content:"";position:absolute;top:0;left:0;width:88px;height:3px;background:#a8323a;}' +
      '.cjs-brand-hero-logo-stage::after{content:"";position:absolute;inset:0;pointer-events:none;background:linear-gradient(120deg,rgba(255,255,255,.48) 0%,rgba(255,255,255,0) 33%,rgba(17,17,17,.025) 100%);}' +
      '.cjs-brand-page__hero-logo-wrap.cjs-brand-hero-logo-panel [data-cjs-brand-hero-logo]{position:relative;z-index:2;display:block!important;width:auto!important;height:auto!important;max-width:var(--cjs-brand-logo-max-width,280px)!important;max-height:135px!important;margin:auto!important;object-fit:contain!important;mix-blend-mode:normal!important;transform:none!important;image-rendering:auto;filter:contrast(1.10) saturate(1.08) drop-shadow(0 3px 3px rgba(0,0,0,.10));}' +
      '@media(max-width:1099px){.cjs-brand-journey-tools__grid{grid-template-columns:repeat(2,minmax(0,1fr));}.cjs-brand-journey-tools__grid[data-cjs-tool-count="1"]{grid-template-columns:minmax(0,360px)}.cjs-brand-page__hero[data-cjs-brand-hero-styled]{min-height:445px!important;}.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__hero-grid{grid-template-columns:minmax(0,1fr) minmax(315px,390px)!important;gap:48px!important;}.cjs-brand-page__hero-logo-wrap.cjs-brand-hero-logo-panel{min-height:245px;padding:24px!important;}.cjs-brand-page__hero-logo-wrap.cjs-brand-hero-logo-panel::before{inset:25px 8px 4px 20px;}.cjs-brand-page__hero-logo-wrap.cjs-brand-hero-logo-panel::after{inset:19px 3px 9px 14px;}.cjs-brand-hero-logo-stage{min-height:200px;padding:34px 36px;}.cjs-brand-page__hero-logo-wrap.cjs-brand-hero-logo-panel [data-cjs-brand-hero-logo]{max-height:125px!important;}}' +
      '@media(max-width:749px){.cjs-brand-journey-tools{padding-top:48px;padding-bottom:48px;}.cjs-brand-journey-tools__grid,.cjs-brand-journey-tools__grid[data-cjs-tool-count="1"],.cjs-brand-journey-tools__grid[data-cjs-tool-count="2"]{grid-template-columns:1fr;max-width:none}.cjs-brand-journey-tools__card{padding:24px 22px!important;}.cjs-brand-journey-tools__card h3{font-size:21px!important;}.cjs-brand-page__hero[data-cjs-brand-hero-styled]{min-height:auto!important;}.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__hero-media{opacity:.09!important;}.cjs-brand-page__hero[data-cjs-brand-hero-styled]::before{opacity:.65;}.cjs-brand-page__hero[data-cjs-brand-hero-styled]::after{right:-34%;bottom:-36%;width:110%;height:100%;opacity:.70;}.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__hero-inner{padding-top:36px!important;padding-bottom:44px!important;}.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__hero-grid{grid-template-columns:1fr!important;gap:32px!important;}.cjs-brand-page__hero[data-cjs-brand-hero-styled] .cjs-brand-page__title{font-size:clamp(39px,12vw,55px)!important;}.cjs-brand-page__hero-logo-wrap.cjs-brand-hero-logo-panel{width:min(94%,390px);min-height:190px;margin:0 auto;padding:20px!important;}.cjs-brand-page__hero-logo-wrap.cjs-brand-hero-logo-panel::before{inset:22px 6px 4px 16px;border-radius:15px;transform:rotate(-2.2deg);}.cjs-brand-page__hero-logo-wrap.cjs-brand-hero-logo-panel::after{inset:17px 1px 9px 11px;border-radius:16px;transform:rotate(-2.2deg);}.cjs-brand-hero-logo-stage{min-height:165px;padding:28px 30px;border-radius:12px;}.cjs-brand-page__hero-logo-wrap.cjs-brand-hero-logo-panel [data-cjs-brand-hero-logo]{max-width:min(var(--cjs-brand-logo-max-width,250px),250px)!important;max-height:110px!important;}}';

    document.head.appendChild(style);
  }

  function run() {
    var page = document.querySelector('.cjs-brand-page');
    if (!page) return;

    addStyles();
    enhanceBrandHero(page);
    replaceWorkshopServices(page);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  window.addEventListener('load', function () { window.requestAnimationFrame(run); });
  document.addEventListener('shopify:section:load', function () { window.requestAnimationFrame(run); });
})();